import { render, staticRenderFns } from "./openbook-item.vue?vue&type=template&id=2df4e122&scoped=true&"
import script from "./openbook-item.vue?vue&type=script&lang=js&"
export * from "./openbook-item.vue?vue&type=script&lang=js&"
import style0 from "./openbook-item.vue?vue&type=style&index=0&id=2df4e122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4e122",
  null
  
)

export default component.exports